import { createEscalaMutationIntent } from './escalaMutationIntent';

const serializar = (valor) => {
	if (Array.isArray(valor)) return valor.map(serializar);
	if (valor && typeof valor === 'object') {
		return Object.keys(valor).sort().reduce((resultado, chave) => {
			if (valor[chave] !== undefined) resultado[chave] = serializar(valor[chave]);
			return resultado;
		}, {});
	}
	return valor;
};

const copiar = (valor) => JSON.parse(JSON.stringify(valor));
const assinatura = ({ scope, body }) => JSON.stringify(serializar({ scope, body }));

// Recebe horários no contrato da API. A seleção pode conter várias faixas na
// mesma data; validar sobreposição e unicidade continua sendo papel do backend.
export const construirLoteDatasAvulsas = (payloadComum = {}, ocorrencias = []) => {
	if (payloadComum.recorrencia != null || payloadComum.periodo != null) {
		throw new Error('Datas avulsas não podem ser combinadas com recorrência ou período.');
	}
	if (!Array.isArray(ocorrencias) || !ocorrencias.length) {
		throw new Error('Informe ao menos uma data e horário para o lote.');
	}
	const { horario, ...campos } = payloadComum;
	return copiar({
		...campos,
		ocorrencias_datas: ocorrencias.map(({ data, hora_inicio, hora_fim }) => ({
			data, hora_inicio, hora_fim,
		})),
	});
};

export const respostaLoteDatasIncerta = (response) => {
	if (response && !response.error) return false;
	const status = Number(response?.error?.status || 0);
	return !status || status === 408 || status >= 500;
};

// Depois de resultado incerto, nenhuma edição visual substitui o comando que
// pode já ter sido confirmado. A próxima tentativa consulta o replay desse lote.
export const criarControleDatasAvulsas = (opcoes = {}) => {
	const intent = createEscalaMutationIntent(opcoes);
	let identidade;
	let pendente = null;
	const controle = {
		setIdentity(token) {
			if (identidade !== token) {
				identidade = token;
				pendente = null;
				intent.setIdentity(token);
			}
		},
		temResultadoIncerto() {
			return Boolean(pendente?.incerta);
		},
		iniciar({ token, scope, body, contexto = {} }) {
			controle.setIdentity(token);
			if (!intent.tryStart()) return null;
			const identidadeTentativa = intent.captureIdentity();
			if (!pendente?.incerta) {
				const decisao = intent.getDecision({ scope, body });
				pendente = {
					decisao,
					request: copiar({ scope, body, idempotencyKey: decisao.key }),
					contexto: copiar(contexto),
					incerta: false,
				};
			}
			const atual = pendente;
			let finalizada = false;
			return {
				request: { token, ...copiar(atual.request) },
				contexto: copiar(atual.contexto),
				ehAtual: () => intent.isCurrentIdentity(identidadeTentativa),
				resultadoIncerto: (response) => Boolean(response?.error) && (atual.incerta || respostaLoteDatasIncerta(response)),
				corresponde: (rascunho) => assinatura(atual.request) === assinatura(rascunho),
				finalizar(response) {
					if (finalizada) return;
					finalizada = true;
					if (intent.isCurrentIdentity(identidadeTentativa)) {
						atual.incerta = atual.incerta || respostaLoteDatasIncerta(response);
						if (response && !response.error) {
							intent.complete(atual.decisao);
							if (pendente === atual) pendente = null;
						}
					}
					intent.release();
				},
			};
		},
	};
	return controle;
};

// Mantém o lock até concluir a atualização pós-sucesso. O callback não roda em
// erro, duplo clique ou resposta de uma identidade que já saiu da tela.
export const enviarLoteDatasAvulsas = async ({
	controle, token, scope, body, contexto, enviar, aoConfirmar,
}) => {
	const tentativa = controle.iniciar({ token, scope, body, contexto });
	if (!tentativa) return null;
	let response;
	try {
		try {
			response = await enviar(tentativa.request);
		} catch (error) {
			response = { error: { status: error?.response?.status || 0, message: error?.message } };
		}
		if (!response) response = { error: { status: 0 } };
		const resultado = {
			response,
			incerta: tentativa.resultadoIncerto(response),
			atual: tentativa.ehAtual(),
			contexto: tentativa.contexto,
			corresponde: tentativa.corresponde,
		};
		if (resultado.atual && !response.error && aoConfirmar) await aoConfirmar(resultado);
		return resultado;
	} finally {
		tentativa.finalizar(response);
	}
};
